import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { AjsResponse, wrapAjs } from "../ajs-response";
import { buildParams, PAGINATION_SEARCH_FIELDS } from "../http-params.util";

/**
 * HistoryApiService (Angular 18).
 *
 * Replaces apps/b2b-ui/common/services/api/historyApi/historyApi.service.js.
 *
 * The legacy service stored an `ApiVersionFactory` instance on the literal
 * which produced `/v2/api/history`. The exception preserved 1:1: the
 * `tenant/calendars` path remains on v1 (the v2 endpoint doesn't exist).
 */
const HISTORY_BASE_V2 = "/v2/api/history";
const HISTORY_BASE_V1 = "/v1/api/history";

const HISTORY_LIST_FIELDS = ["type", ...PAGINATION_SEARCH_FIELDS] as const;

@Injectable({ providedIn: "root" })
export class HistoryApiService {
  private readonly http = inject(HttpClient);

  list(
    id: number | string | null | undefined,
    path: string,
    props?: Record<string, unknown>,
  ): Promise<AjsResponse<unknown>> {
    const base =
      path === "tenant/calendars" ? HISTORY_BASE_V1 : HISTORY_BASE_V2;
    let url = `${base}/${path}`;
    if (id) url += `/${id}`;
    return wrapAjs(
      this.http.get<unknown>(url, {
        params: buildParams(props, HISTORY_LIST_FIELDS),
      }),
    );
  }

  // Note: legacy `detail(id, path)` ignored `path` and went straight to
  // `/history/:id`. Preserved (the `path` param is documented but unused).
  detail(id: number | string, _path?: string): Promise<AjsResponse<unknown>> {
    return wrapAjs(this.http.get<unknown>(`${HISTORY_BASE_V2}/${id}`));
  }

  readonly auditTrail = {
    list: (
      version: string | number,
      id: number | string,
      path: string,
    ): Promise<AjsResponse<unknown>> =>
      wrapAjs(
        this.http.get<unknown>(
          `${HISTORY_BASE_V2}/${path}/${id}/diff/${version}`,
        ),
      ),
  };
}
